// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__dVyML","mobileSpacer":"Layout_mobileSpacer__RG+OY"};